import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from "react-i18next";
import Portfolio from "./Portfolio";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { RecruiterOpportunities } from "./RecruiterOpportunities";

interface ProfileTabsProps {
  profile: any;
  isOwnProfile: boolean;
  isVisitorView: boolean;
}

export const ProfileTabs = ({
  profile,
  isOwnProfile,
  isVisitorView,
}: ProfileTabsProps) => {
  const { t } = useTranslation();

  // Fetch user role
  const { data: userRole } = useQuery({
    queryKey: ["userRole", profile.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", profile.id)
        .maybeSingle();

      if (error) {
        console.error("Error fetching user role:", error);
        return null;
      }

      return data?.role;
    },
  });

  // Show opportunities for recruiter profiles
  if (userRole === "recruiter") {
    return (
      <div className="space-y-6">
        <RecruiterOpportunities profileId={profile.id} />
      </div>
    );
  }

  // Show portfolio tab for talent profiles
  return (
    <Tabs defaultValue="portfolio" className="w-full">
      <TabsList>
        <TabsTrigger value="portfolio">
          {t('profile.tabs.portfolio')}
        </TabsTrigger>
      </TabsList>

      <TabsContent value="portfolio">
        <Portfolio
          userId={profile.id}
          isEditing={isOwnProfile && !isVisitorView}
        />
      </TabsContent>
    </Tabs>
  );
};